<template lang="pug">
  div.map-container.geo.map-treads
    router-view

    div.toolbar
      div.line
        h1.title {{$translate('Схема потоков отходов')}}
      div.line
        div.actions-panel

    div(style="z-index:9").map-year-track.mapYearTrack
      div(
        v-if="yearList"
      ).date Дата:
        span.year {{year}}
          div.track-wrapper
            span.year-start {{min}}
            div.track
              el-slider(
                style="width:100%;"
                :min="min"
                :max="max"
                v-model="year"
                @change="yearHandler"
                :step="1"
                show-stops
              )
            span.year-start {{max}}
      div(
        v-else
      ).date
        span.year
          div.track-wrapper
            span.year-start
            div.track {{$translate('Прогнозы не ')}}
            span.year-start

    div.new-map
      div(ref="map" v-once).bigmap#map
      map-legend(
        :showRemoved="true"
        @showAll="showAll"
        @showAllThreads="showAllThreads"
        @showModelTariffs="showModelTariffsHandle"
        @showStatusPlan="showStatusPlan"
        @showHideLine='showHideLine'
        @initThreadTypes='initThreadTypesKeys'
        @showStatusActive="showStatusActive")
</template>

<script>
  import mapLegend                from "./components/map-legend.vue"
  import baseMap                  from "./mixins/base-map.js"
  import mappingMixin             from "./mixins/mapping-mixin"
  import {threadsDateSliderMixin} from "./mixins/threads/date-slider"
  import {map as mapEndpoints }   from '../../api/api-endpoints.js'
  import year                     from '../../utils/year.js'
  import measureMixin             from './mixins/measure-mixin'
  import url                      from "../../utils/url"
  import {MAP}                    from '@/config/map'
  import ThreadsDrawer            from "./utils/ThreadsDrawer"
  import { ZONES }                from '@/app/geo/config/config'

  export default {
    name: 'treads',
    data() {
      this.map = null;
      return {
        q: '',
        showRight: true,
        showMapCard: false,
        selectedMappingObject: ZONES,
        selectedMappingObjectZoom: null,
      }
    },
    mounted() {
      this.onMappingCurrentLegend()
      this.refreshMap()
    },
    mixins: [baseMap, mappingMixin, measureMixin, threadsDateSliderMixin],
    components: {
      mapLegend
    },
    computed: {
      contextmenu () {
        return false
      },
      contextmenuOpened () {
        return true
      },
      mappingCurrentLegend() {
        let currentOnZoom = null
        if (this.selectedMappingObject && this.selectedMappingObjectZoom) {
          let zoom    = this.selectedMappingObjectZoom
          let current = this.mappingConfObject[this.selectedMappingObject]
          current.legends.forEach(v => {
            if (v.hasOwnProperty('showOnZoom') && v.showOnZoom.indexOf(zoom) > -1) {
              currentOnZoom = v
            } else if (!currentOnZoom) {
              currentOnZoom = v
            }
            if (currentOnZoom) {
              if (!v.title) {
                currentOnZoom.title = current.title
              }
              currentOnZoom.items.forEach((item, i) => {
                currentOnZoom.items[i].style = Object.assign(
                  currentOnZoom.items[i].style || {},
                  v.style || {}
                )
              })
            }
          })
        }
        return currentOnZoom
      }
    },
    methods: {
      initThreadTypesKeys(typeKeys) {
        this.allowThreadTypes = typeKeys;
        this.refreshMap();
      },
      afterMapInit() {
        this.threadsDrawer = new ThreadsDrawer(this.map, this);
        this.subsSetView = this.$emitter.listen('geo.mapSetView', this.setView);
        this.subsUpdateMap = this.$emitter.listen('geo.mapUpdate', this.updateMap);
        this.subsRefreshMap = this.$emitter.listen('geo.mapRefresh', this.refreshMap)
      },
      letSearch(){
        this.replaceRoute({q: this.q}, false)
      },
      getThreadEndpoint(route) {
        if (!route.query.year) {
          route.query.year = year.getCurrentYear()
        }
        if (!route.query?.flows) {
          route.query.flows = true
        }
        return mapEndpoints.threads(route)
      },
      getSettlementEndpoint(route) {
        route.query.flows = true
        return mapEndpoints.settlements(route)
      },
      getMapTkoObjectsEndpoint (route) {
        route = route || this.$route
        if (!route?.query?.year) {
          route.query.year = year.getCurrentYear()
        }
        return mapEndpoints.objectForThreads(route)
      },
      getGarbageSourceEndpoint(route) {
        return mapEndpoints.garbageSources(route)
      },
    },
    asyncData ({store, route, methods}) {
      let promises = [];
      let usedRoute = url.getPrevOrCurrentRoute(route);
      if(methods.getThreadEndpoint){
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getThreadEndpoint(route),
          fromCache: false,
          notReactive: false
        }))
      }
      if(methods.getSettlementEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getSettlementEndpoint(route, usedRoute),
          fromCache: false,
          notReactive: false
        }))
      }

      if (methods.getMapTkoObjectsEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getMapTkoObjectsEndpoint(route),
          fromCache: false,
          notReactive: false
        }))
      }
      if (methods.getGarbageSourceEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getGarbageSourceEndpoint(route),
          fromCache: false,
          notReactive: false
        }))
      }

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
        fromCache: false,
        notReactive: false
      }));

      if (methods.getYearListEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getYearListEndpoint(),
          fromCache: true,
          cache: true,
          notReactive: false
        }))
      }

      return Promise.all(promises)
    },
    destroyed () {
      this.destroyMap();
      this.destroyAsync()
    },
    destroyAsync () {
      this.$store.commit('skipAsyncData', {name: 'geo.*', depth: 1, value: false});
      if (this.subsSetView) {
        this.subsSetView.unsubscribe()
      }
      if (this.subsUpdateMap) {
        this.subsUpdateMap.unsubscribe()
      }
      if (this.subsRefreshMap) {
        this.subsRefreshMap.unsubscribe()
      }
      if (this.threadsDrawer) {
        this.threadsDrawer.destroy()
      }
    },
  };
</script>
